.wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-left: calc(var(--spacer) * 5);
  padding-top: calc(var(--spacer) * 3);
}

#downloadInstructions {
  max-width: 700px;
  padding-bottom: calc(var(--spacer) * 5);
  opacity: 0.7;
}

#kubernetesTitle,
#helmTitle,
#openShiftTitle {
  padding-bottom: calc(var(--spacer) * 3);
  text-transform: uppercase;
  color: var(--chart-302-icon-buttons-titles);
  line-height: 1.1;
}

gz-copy-to-clipboard {
  width: 700px;
  height: auto;
  margin-bottom: calc(var(--spacer) * 4);
}

.text-placeholder {
  border: 1px solid var(--chart-101-pressed-dividers);
  padding: calc(var(--spacer) * 2);
  border-radius: var(--widget-border-radius);
  color: var(--body-text-arrows-400);
}
